import dayjs from 'dayjs'
import { LabelKey, LabelTextValue } from '.'

interface Props {
  date: string
}
export const Release: React.FC<Props> = ({ date }) => {
  return (
    <div className="sm:flex sm:pb-[6px] w-full text-[15px] sm:text-base leading-9 sm:leading-base align-top sm:align-middle">
      <LabelKey text="出版日" />
      <LabelTextValue text={dayjs(date).format('YYYY年MM月DD日')} />
    </div>
  )
}
